// extracted by mini-css-extract-plugin
export var childrenContainer = "_9n-0";
export var virtualScrollArea = "_9n-1";